import { connect, ConnectedProps } from "react-redux";

import { MonthAndDatePicker } from "./component";

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MonthAndDatePickerConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedMonthAndDatePicker = connector(MonthAndDatePicker);
